import i18n from "../../../i18n";

const AnalysisSalesLotGridPluginSettings = (): IPluginSettings => {
    const t = (value: string) => i18n.t("sidePanel." + value);
    let index = 0
    return {
        name: t("accounting.submenu.analysisLot"),
        mnemocode: 'analysis_sales_lot_plugin',
        permission: 'Lot',
        columns: [{
            order: index++,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'IdGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'idContractorGlobal',
            propertyType: 'string',
            displayName: 'idContractorGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'idGoodsGlobal',
            propertyType: 'string',
            displayName: 'idGoodsGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'idProducerGlobal',
            propertyType: 'string',
            displayName: 'idProducerGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'idStoreGlobal',
            propertyType: 'string',
            displayName: 'idStoreGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'goodsName',
            propertyType: 'string',
            displayName: 'Товар',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'dateSales',
            propertyType: 'datetime',
            displayName: 'Дата продажи',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'currentPeriodSales',
            propertyType: 'number',
            displayName: 'Количество продаж в текущем периоде',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'previousPeriodSales',
            propertyType: 'number',
            displayName: 'Количество продаж в предыдущем периоде',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'currentPeriodSum',
            propertyType: 'number',
            displayName: 'Сумма продаж в текущем периоде, руб.',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'previousPeriodSum',
            propertyType: 'number',
            displayName: 'Сумма продаж в предыдущем периоде, руб.',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'salesDiffRub',
            propertyType: 'number',
            displayName: 'Потерянная выручка, руб.',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'likeForLikePercent',
            propertyType: 'number',
            displayName: 'MoM, %',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'quantityTotal',
            propertyType: 'number',
            displayName: 'Общее количество',
            visibility: true,
            width: 150
        },{
            order: index++,
            propertyName: 'goodsNameShort',
            propertyType: 'string',
            displayName: 'Короткое наименование',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'goodsCode',
            propertyType: 'string',
            displayName: 'Код товара',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'countryName',
            propertyType: 'string',
            displayName: 'Страна',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'internalBarcode',
            propertyType: 'string',
            displayName: 'Внутренний штрихкод',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'producerName',
            propertyType: 'string',
            displayName: 'Производитель',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'scalingRatioDisplayName',
            propertyType: 'string',
            displayName: 'Упаковка',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'storeName',
            propertyType: 'string',
            displayName: 'Склад',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'tradeNameRus',
            propertyType: 'string',
            displayName: 'ТН (рус)',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'tradeNameLat',
            propertyType: 'string',
            displayName: 'ТН (лат)',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'isGnvls',
            propertyType: 'boolean',
            displayName: 'ЖНВЛП',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'isKiz',
            propertyType: 'boolean',
            displayName: 'Киз',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'isKizBox',
            propertyType: 'boolean',
            displayName: 'Короб',
            visibility: true,
            width: 150
        }, 
        {
            order: index++,
            propertyName: 'isKizFlag',
            propertyType: 'boolean',
            displayName: 'КИЗ',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'quantityAdd',
            propertyType: 'number',
            displayName: 'Кол-во (Добавлено)',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'quantitySub',
            propertyType: 'number',
            displayName: 'Кол-во (Проведено)',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'quantityRem',
            propertyType: 'number',
            displayName: 'Кол-во (Остаток)',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'quantityRes',
            propertyType: 'number',
            displayName: 'Кол-во (Зарезервировано)',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'productMargin',
            propertyType: 'number',
            displayName: 'Наценка',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailPrice',
            propertyType: 'number',
            displayName: 'Цена розн.',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailPriceIncVat',
            propertyType: 'number',
            displayName: 'Цена розн. c НДС',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailSum',
            propertyType: 'number',
            displayName: 'Сумма розн.',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailSumIncVat',
            propertyType: 'number',
            displayName: 'Сумма розн. с НДС',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailVat',
            propertyType: 'number',
            displayName: 'НДС розн.',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailVatSum',
            propertyType: 'number',
            displayName: 'Сумма НДС розн.',
            visibility: true,
            width: 150
        }, 
        {
            order: index++,
            propertyName: 'supplierPrice',
            propertyType: 'number',
            displayName: 'Цена поставщика',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'supplierPriceIncVat',
            propertyType: 'number',
            displayName: 'Цена поставщика с НДС',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'supplierSum',
            propertyType: 'number',
            displayName: 'Сумма поставщика',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'supplierSumIncVat',
            propertyType: 'number',
            displayName: 'Сумма поставщика c НДС',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'supplierVat',
            propertyType: 'number',
            displayName: 'НДС поставщика',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'supplierVatSum',
            propertyType: 'number',
            displayName: 'Сумма НДС поставщика',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'dateModified',
            propertyType: 'datetime',
            displayName: 'Дата изменения',
            visibility: true,
            width: 150
        }, 
        {
            order: index++,
            propertyName: 'deleted',
            propertyType: 'boolean',
            displayName: 'Удален',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'dateDeleted',
            propertyType: 'datetime',
            displayName: 'Дата удаления',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'supplier',
            propertyType: 'string',
            displayName: 'Поставщик',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'seriesBestBefore',
            propertyType: 'date',
            displayName: 'Срок годности',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'seriesNumber',
            propertyType: 'string',
            displayName: 'Серия',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'contractorName',
            propertyType: 'string',
            displayName: 'Аптека',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'taskProgramName',
            propertyType: 'string',
            displayName: 'ЦП ГК',
            visibility: false,
            width: 150
        },
        {
            order: index++,
            propertyName: 'gosContractName',
            propertyType: 'string',
            displayName: 'ГК',
            visibility: false,
            width: 150
        },
        {
            order: index++,
            propertyName: 'mnn',
            propertyType: 'string',
            displayName: 'МНН',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'registerPrice',
            propertyType: 'number',
            displayName: 'Цена реестра',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'dateDocument',
            propertyType: 'datetime',
            displayName: 'Дата документа', 
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'barcodeCode',
            propertyType: 'string',
            displayName: 'Заводской штрихкод',
            visibility: true,
            width: 150
        }
        ]
    }
}
export default AnalysisSalesLotGridPluginSettings